import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Progress } from '../../ui/progress';
import { KindIcon } from '../QualityBadges';
import { scoreTone } from '../qualityConfig';

const tooltipStyle = { background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: 12, fontSize: 12 };

export const ReportTrendChart = ({ data, bucket }) => (
    <Card className="lg:col-span-8" data-testid="report-trend-chart">
        <CardHeader className="pb-2">
            <CardTitle className="font-heading text-lg">Assigned vs completed {bucket === 'day' ? 'by day' : 'by month'}</CardTitle>
        </CardHeader>
        <CardContent>
            {data.length === 0 ? <p className="py-16 text-center text-sm text-muted-foreground">No tasks in this period yet.</p> : (
                <ResponsiveContainer width="100%" height={280}>
                    <ComposedChart data={data} margin={{ top: 8, right: 4, left: -16, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
                        <XAxis dataKey="label" tick={{ fontSize: 11 }} interval="preserveStartEnd" stroke="hsl(var(--muted-foreground))" />
                        <YAxis yAxisId="count" allowDecimals={false} tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" />
                        <YAxis yAxisId="score" orientation="right" domain={[0, 100]} tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" />
                        <Tooltip contentStyle={tooltipStyle} cursor={{ fill: 'hsl(var(--muted))', opacity: 0.4 }} />
                        <Legend wrapperStyle={{ fontSize: 12 }} />
                        <Bar yAxisId="count" dataKey="assigned" name="Assigned" fill="#6366f1" radius={[4, 4, 0, 0]} maxBarSize={28} />
                        <Bar yAxisId="count" dataKey="completed" name="Completed" fill="#10b981" radius={[4, 4, 0, 0]} maxBarSize={28} />
                        <Bar yAxisId="count" dataKey="missed" name="Missed" fill="#f43f5e" radius={[4, 4, 0, 0]} maxBarSize={28} />
                        <Line yAxisId="score" type="monotone" dataKey="avg_score" name="Avg score" stroke="#a855f7" strokeWidth={2.5} dot={{ r: 3 }} connectNulls />
                    </ComposedChart>
                </ResponsiveContainer>
            )}
        </CardContent>
    </Card>
);

export const ReportByKind = ({ rows }) => (
    <Card className="lg:col-span-4" data-testid="report-by-kind">
        <CardHeader className="pb-2"><CardTitle className="font-heading text-lg">By simulation type</CardTitle></CardHeader>
        <CardContent className="space-y-4">
            {rows.map((r) => (
                <div key={r.kind} className="flex items-center gap-3" data-testid={`report-kind-${r.kind}`}>
                    <KindIcon kind={r.kind} size="h-8 w-8" />
                    <div className="min-w-0 flex-1">
                        <div className="flex items-baseline justify-between gap-2">
                            <p className="truncate text-sm font-medium">{r.label}</p>
                            <p className="font-mono text-xs tabular-nums text-muted-foreground">{r.completed}/{r.assigned}</p>
                        </div>
                        <Progress value={r.assigned ? (r.completed / r.assigned) * 100 : 0} className="mt-1.5 h-1.5" />
                    </div>
                    <p className={`w-10 text-right font-heading text-lg font-bold tabular-nums ${scoreTone(r.avg_best_score)}`}>{r.avg_best_score ?? '—'}</p>
                </div>
            ))}
            <p className="text-xs text-muted-foreground">Done/assigned simulations and the average best score.</p>
        </CardContent>
    </Card>
);
